/* eslint-disable react/no-unescaped-entities */
import React from 'react';

const Parks = ({title, subTitle1, subTitle2, image, animationImage, list}) => {
	return (
		<div>
			{/* <!-- Perks --> */}
			<section className="relative py-24">
				<div className="container">
					<div className="lg:flex lg:justify-between items-center">
						{/* <!-- Image --> */}
						<div className="lg:w-[55%]">
							<div className="relative">
								<img
									src={image}
									width="200"
									height="200"
									className="mx-auto mt-8 w-[80%] rotate-[8deg] rounded-[10rem]"
								/>
								<img
									src={animationImage}
									alt=""
									className="absolute top-0 animate-fly"
								/>
							</div>
						</div>

						{/* <!-- Info --> */}
						<div className="py-20 lg:w-[45%] lg:pl-16">
							<h2 className="mb-6 font-display text-2xl text-jacarta-700 dark:text-white">
                {title}
							</h2>
              {subTitle1 && (
                <p className="mb-8 text-lg leading-normal dark:text-jacarta-300">
                  {subTitle1}
                </p>
              )}
              {subTitle2 && (
                <p className="mb-10 dark:text-jacarta-300">
                  {subTitle2}
                </p>
              )}
							<div className="flex space-x-4 sm:space-x-12">
                {list?.map((item, index) => {
                  return (
                    <div key={`row-${index}`} className={item.containerClass}>
                      {item?.row?.map((row, i) => (
                        <div key={i} className="mb-5 flex space-x-4">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="h-8 w-8 shrink-0 fill-primary"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16z" />
                          </svg>
                          <div>
                            <span className="block font-display text-base text-jacarta-700 dark:text-white">
                            {row?.title}
                          </span>
                            {row?.desc && (
                              <p className="mt-1 dark:text-jacarta-300">
                                {row.desc}
                              </p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )
                })}
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <!-- end perks --> */}
		</div>
	);
};

export default Parks;
